<div id="{{'message-'+message.conversationMessageId}}" class="chatMessage"  placement="auto">
	<ng-container>
		<div class="chatMessage__content" [ngClass]="(messageNick == 'You' || messageNick == conversation.receiverNick)?'my-message':'other-message'">
 
			<ng-container *ngIf="messageNick == 'other'">

         <mat-icon aria-hidden="false" aria-label="message delivered" *ngIf="message.delivered">done_all</mat-icon>
         <mat-icon aria-hidden="false" aria-label="message delivered" *ngIf="!message.delivered">done</mat-icon>
			</ng-container>

			<div class="chatMessage__contentText">
				<div class="d-flex flex-row justify-content-between">
					<div class="font-weight-light small mh-100">{{messageNick}}:</div>
					<span class="chatMessage__date">{{formatDate(message.creationDate)}}</span>
        </div>
        {{ message.content }}
      </div>

      <div class="chatMessage__imagesWrap" *ngIf="hasImages(conversation.conversationId,message.conversationMessageId)">
        <!-- <ngx-image-swiper [config]="swiperConfig" [images]="images" (imageClick)="imageClick($event)"></ngx-image-swiper> -->
        <div class="chatMessage__image" *ngFor="let image of images">
          <img src="{{image}}"/>
        </div>
      </div>

    </div>
  </ng-container> 
</div>

<ng-template  #imageDialog let-data>
  <div class="imageDialog__content" mat-dialog-content><img [src]="data"/></div>
</ng-template>